<template>
    <basic-header
        pretitle="aqfer Universal Tag"
        title="Custom Initiator Fields"
        buttonText="Add Initiator Field"
        :buttonRoles="btnRoles"
        @btnClick="showModal({ component: 'AddClientInitiatorField' })"
    />

    <div class="container-fluid">
        <div class="card">
            <datatable
                tableId="clientInitiatorFieldsList"
                :columns="columns"
                :data="$store.state.aut.cidInitiatorFields"
                @deleteRows="showDeleteClientInitiatorFields"
                :deletable="deletable"
                :compact="true"
                :selectCheckboxes="true"
                uniqueField="name"
                :detailColumn="{baseUrl:'client-initiator-fields/', name:'Client Initiator Field', identifier:'name', identifierName:'name'}"
                :dropDownFilterColumn=dropDownFilterColumn
            />
        </div>
    </div>
</template>

<script>
import BasicHeader from "../../components/BasicHeader.vue";
import Datatable from "../../components/Datatable.vue";
import { mapActions } from "vuex";

export default {
    name: "ClientInitiatorFields",
    components: { BasicHeader, Datatable },
    data() {
        return {
            columns: [
                {
                    data: "name",
                    title: "Name",
                    render: function (data, type, row) {
                        if (!row.description || row?.description=="") return data;
                        return `<span class="datatable-title">${data}</span><span   v-if="${row.description!==''}" class="fa fa-circle-info mx-1 text-muted" data-bs-title="${row.description}"  data-bs-toggle="tooltip" data-bs-placement="top" data-bs-container="body" data-bs-html="true"></span>`
                    },
                },
                { data: "initiator", title: "Initiator" },
                { data: "input" },
                { data: "parameter"},
                { data: "rank" }
            ],
            //Note: client admins manage their own initiator fields, so rank 3 is
            //allowed here even though the global pages stay aqfer-only
            btnRoles: [1, 1.5, 3],
            allowedRoles: [1, 1.5, 3],
            dropDownFilterColumn: [ 3 ]
        };
    },
    beforeMount() {
        this.$store.dispatch("aut/fetchCidInitiatorFields");
    },
    methods: {
        showDeleteClientInitiatorFields(rows) {
            this.showModal({ component: "DeleteClientInitiatorFields", data: rows });
        },
        ...mapActions({
            showModal: "showModal",
        }),
    },
    computed: {
        deletable() {
            return this.allowedRoles.includes(this.$store.getters.userRoles.userRoleRank);
        }
    }
};
</script>

<style scoped>
</style>
